/*!
 * Bootstrap v3.3.5 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

/*!
 * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=2fcb12636d6a6a942b85)
 * Config saved to config.json and https://gist.github.com/2fcb12636d6a6a942b85
 */
if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}
+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 2)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.3.6
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.6'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);


$(document).ready(function() {
  $(".owl-carousel").each(function(){
    var config = { 
        slideSpeed : 300,
        paginationSpeed : 400, 
        autoHeight: false
     }; 

    var owl = $(this);
    if( $(this).data('slide') == 1 ){
        config.singleItem = true;
    }else {
        config.items = $(this).data( 'slide' );
    }
    if ($(this).data('desktop')) {
        config.itemsDesktop = $(this).data('desktop');
    }
    if ($(this).data('desktopsmall')) {
        config.itemsDesktopSmall = $(this).data('desktopsmall');
    }
    if ($(this).data('desktopsmall')) {
        config.itemsTablet = $(this).data('tablet');
    }
    if ($(this).data('tabletsmall')) {
        config.itemsTabletSmall = $(this).data('tabletsmall');
    }
    if ($(this).data('mobile')) {
        config.itemsMobile = $(this).data('mobile');
    }
    if ($(this).data('autoplay')) {
      config.autoPlay = $(this).data('autoplay');
    }
    $(this).owlCarousel( config );
  });

  $(".slider-carousel .owl-buttons").click(function() {
    new WOW().init();
  });
  
  $('body').on('mouseenter','.swatch-element', function(){
    var image = $(this).data('image');
    if ( image && typeof image != 'undefined' ) {
      $(this).parent().parent().find('.product-thumbnail img.back-img').attr('src', image);
    }
    return true;
  });

  initSwatch();

  // carousel lite
  $(".lite-carousel-play div[data-carousel=lite]").each(function(){
    var config = {
      btnNext: ".lite-carousel-play .next",
      btnPrev: ".lite-carousel-play .prev",
      vertical: true
    };
    if ( $(this).data('visible') ) {
      config.visible = $(this).data('visible');
    }else {
      config.visible = 3;
    }

    var jcarousel = $(this);
    $(this).jCarouselLite( config );

  });

  $('.slick-carousel').slick({
    arrows    : true,
    vertical  : true,
    responsive: [
      {
        breakpoint: 992,
        settings  : {
          vertical: false,
        }
      },
      {
        breakpoint: 480,
        settings  : {
          vertical: false,
        }
      }
    ]
  });

});

function initSwatch() {$(".swatch :radio").change(function() {var t = $(this).closest(".swatch").attr("data-option-index");var n = $(this).val();$(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")});$(".hover-bimg").mouseenter(function() {$(this).closest('.product-image-container').find('.product_img_link').first().find('img').first().attr('src', $(this).data('bimg'));});$(".nav-verticalmenu .caret").click(function(e) {$(this).closest("li").toggleClass("menu-open");e.stopPropagation();});}


//Sticky Menu
$(document).ready(function() {
  if ($('.keep-this').length > 0) {
    var _menu_action = $('.keep-this').offset().top;

    var OC_Menu_Fixed = function(){
        "use strict";

        var $mainmenu = $('.keep-this');

        if( $(document).scrollTop() > _menu_action ){
          $mainmenu.addClass('menu_fixed');
        }else{
          $mainmenu.removeClass('menu_fixed');
        }
    }
    $(window).scroll(function(event) {
        OC_Menu_Fixed();
    });
  }
});